import { DefaultModel } from 'src/app/core/framework/default.model';
import { IEndereco } from '../gis/endereco/endereco.interface';

export class Paciente extends DefaultModel {

  nome: string;

  cpf: string;

  sexo: string;

  dataNascimento: Date;

  idExterno: string;
  
  endereco?: IEndereco;

  telefone ?: string;

  email?: string;

  //FIXME: remover este campo e aplicar mascara nos locais onde eh utilizado
  dataNascimentoDiaMesAno?: string;

  //FIXME: remover este campo e aplicar mascara nos locais onde eh utilizado
  idadePorExtenso?: string;
}

